import { buildNonResizableImageUrl } from '@autone/utils';
import { type HTMLMotionProps, motion } from 'motion/react';
import { useEffect, useState } from 'react';

import { cn } from '../../../utils';
import { useSidebarContext } from '../context/SidebarContext';

function SidebarAutoneLogo({
  ...props
}: Omit<HTMLMotionProps<'img'>, 'ref'> & { baseUrl?: string }) {
  const { open } = useSidebarContext();

  // needed without AnimatePresence to avoid initial animation on mount
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);

  const logoSrc = open
    ? buildNonResizableImageUrl('autone-logos/Autone_Complet_White.svg')
    : buildNonResizableImageUrl('autone-logos/autone-icon-white.svg');

  return (
    <div
      className={cn(
        'w-[150px] h-[88px] relative flex [[data-state=collapsed]_&]:justify-center [[data-state=collapsed]_&]:w-full',
        '[[data-state=expanded]_&]:px-4',
      )}
    >
      {/* Not using the more typical AnimatePresence here due to conflicts with other css classes */}
      <motion.img
        key={`${open}`}
        src={logoSrc}
        alt={open ? 'Autone Full Logo' : 'Autone Icon'}
        className="object-contain block"
        initial={hasMounted ? { opacity: 0, scale: 0.9 } : false}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.6, ease: 'easeInOut' }}
        style={{
          backfaceVisibility: 'hidden',
        }}
        {...props}
      />
    </div>
  );
}

export { SidebarAutoneLogo };
